<template>
  <div
    ref="el"
    class="accordion"
    :class="{'accordion_open': isOpen}"
  >
    <div class="accordion__heading" @click="toggle">
      <p v-html="heading"></p>
    </div>
    <div v-if="isOpen" class="accordion__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['heading', 'anchor'],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
  mounted() {
    if (window.location.hash.length > 1) {
      this.isOpen = window.location.hash.slice(1) === this.anchor;

      if (!this.isOpen) {
        return;
      }

      setTimeout(() => {
        const top = this.$refs.el.getBoundingClientRect().top + document.body.scrollTop - 10;
        window.scroll({
          top,
          behavior: 'smooth',
        });
      }, 300);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.accordion {
  border-radius: 5px;
  border: 1px solid var(--tertiary-accent);

  &_open {
    .accordion__heading {
      border-bottom: 1px solid var(--tertiary-accent);

      &:before {
        transform: rotate(180deg);
      }
    }
  }

  &__heading {
    font-size: 15px;
    padding: 10px;
    display: flex;
    align-items: center;
    line-height: 17px;
    cursor: pointer;
    user-select: none;

    @include notebook {
      font-size: 14px;
    }

    &:before {
      content: '';
      display: block;
      flex: 0 0 15px;
      width: 15px;
      height: 15px;
      background-image: url('~@/assets/icon-dropdown.svg');
      background-size: 90%;
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 5px;
    }

    &::v-deep {
      b {
        font-weight: 700;
      }
    }
  }

  &__content {
    padding: 10px;
  }
}
</style>
